import { clear, del, get, keys, set, setMany } from 'idb-keyval';

const STORAGE_TYPE = 'indexeddb'; // set to 'indexeddb' after migration complete

export const storage = {
  STORAGE_TYPE,
  idbGet: get,
  idbSet: set,
  async getItem(key) {
    if (STORAGE_TYPE === 'indexeddb') {
      return await get(key);
    } else {
      const value = localStorage.getItem(key);
      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    }
  },
  async setItem(key, value) {
    if (STORAGE_TYPE === 'indexeddb') {
      return await set(key, value);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  },
  async setItemMany(items) {
    if (STORAGE_TYPE === 'indexeddb') {
      return await setMany(items);
    }
  },
  async removeItem(key) {
    if (STORAGE_TYPE === 'indexeddb') {
      return await del(key);
    } else {
      localStorage.removeItem(key);
    }
  },
  async clear() {
    if (STORAGE_TYPE === 'indexeddb') {
      return await clear();
    } else {
      localStorage.clear();
    }
  },
  async keys() {
    if (STORAGE_TYPE === 'indexeddb') {
      return await keys();
    } else {
      return Object.keys(localStorage);
    }
  },
};
